export default __webpack_public_path__ + "static/media/vendor_bill.c470ef72.xlsx";